export default "__VITE_ASSET__CbmHha4o__"